import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

async function getDocuments(type) {
  const url = `${API_URL}/Document?type=${encodeURIComponent(type)}`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include',
    });

    if (response.status === 401) {
      window.dispatchEvent(new Event('app:unauthorized'));
      throw new Error('Unauthorized');
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Failed to fetch document', error);
    throw error;
  }
}

async function uploadDocument(fileName, title, type, file) {
  const url = `${API_URL}/Document/uploadDocument`;
  const formData = new FormData();

  formData.append('fileName', fileName);
  formData.append('title', title);
  formData.append('type', type);
  formData.append('file', file);

  try {
    const response = await axios.post(url, formData, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      validateStatus: (status) => true, 
    });

    if (response.status === 401) {
      window.dispatchEvent(new Event('app:unauthorized'));
      throw new Error('Unauthorized');
    }

    if (response.status < 200 || response.status >= 300) {
      throw new Error(
        response.data?.message || `Upload failed (status: ${response.status})`
      );
    }

    return response.data;
  } catch (error) {
    console.error('There was an error uploading the file!', error);
    throw error;
  }
}

export default { getDocuments, uploadDocument };
